import config from './config';

import en from './default/translations/en-GB.json';

const { locales } = config;
const translations = { 'en-GB': en };

export { translations, locales };
